import { render, staticRenderFns } from "./ApprList.vue?vue&type=template&id=1d795079&scoped=true&"
import script from "./ApprList.vue?vue&type=script&lang=js&"
export * from "./ApprList.vue?vue&type=script&lang=js&"
import style0 from "./ApprList.vue?vue&type=style&index=0&id=1d795079&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d795079",
  null
  
)

export default component.exports